var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mx-2 field"},[_c('TextField',{attrs:{"hide-details":"auto","rules":"required|integer","label":_vm.$t('tracks.block_repeats_days_label')},model:{value:(_vm.cycleFrequencyInDays),callback:function ($$v) {_vm.cycleFrequencyInDays=$$v},expression:"cycleFrequencyInDays"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }